import { useState } from 'react';
import {
    membershipButton, membershipContainer, membershipModal, sectionTitleStyles, priceNumberStyles, priceDurationStyles, membershipFeaturesStyles, membershipFeatureStyles, primaryButtonStyles, secondaryButtonStyles, popularBadgeStyles, membershipNameStyles, popularCardStyles, centerDescStyles,
    inputStyles, membershipGridStyles, membershipCardStyles, pageHeaderSubStyles, pageHeaderTitleStyles, pageHeaderStyles, sectionStyles, containerStyles, formDisclaimerStyles, textareaStyles, labelStyles, formGroupStyles, formRowStyles, membershipHeaderStyles, membershipPriceStyles} from './styles';
import { loadStripe } from '@stripe/stripe-js';
import { 
  Elements, 
  CardElement, 
  useStripe, 
  useElements,
  PaymentElement
} from '@stripe/react-stripe-js';
  const membershipFormSectionStyles = { backgroundColor: '#f8f9fa', padding: '4rem 0', borderRadius: '15px' };
  const membershipFormStyles = { backgroundColor: 'white', padding: '2rem', borderRadius: '15px', maxWidth: '600px', margin: '0 auto', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' };

// Existing styles and other imports...

const stripePromise = loadStripe('pk_live_51S5uZQPcIirE4Ow6UHQQfFxYLQtsfLP45c3MNWk21IImtIWIDinfSDSQ5jgnOV1p8g2b0hbMdZ3rkrOsZGoXTp6200XSaFNZKB');

const MembershipPaymentForm = ({ 
  tier, 
  membershipForm, 
  showNotification, 
  onPaymentSuccess 
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePaymentSubmission = async (event) => {
    event.preventDefault();
    
    // Check if membership is free
    if (tier.price === 'Free' || parseFloat(tier.price.replace('£', '')) === 0) {
      try {
        // Submit membership application directly
        const membershipResponse = await fetch('/api/members', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
                ...membershipForm,
                membershipTier: tier.name,
                paymentIntentId: "" // No payment for free tier
          }),
        });

        if (membershipResponse.ok) {
          showNotification('Free membership registered successfully!', 'success');
          onPaymentSuccess();
        } else {
          const errorData = await membershipResponse.json();
          showNotification(errorData.detail || 'Membership application failed', 'error');
        }
      } catch (error) {
        console.error('Free membership registration error:', error);
        showNotification('Registration processing failed', 'error');
      }
      return;
    }

    // Existing Stripe payment flow for paid memberships
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      return;
    }

    setIsProcessing(true);

    try {
      // Create payment intent on backend

        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: window.location.href,
            },
            redirect: "if_required",
        });

        if (result.error) {
            // Show error to your customer
            showNotification(result.error.message, 'error');
            setIsProcessing(false);
        } else {
            // Payment succeeded
            if (result.paymentIntent.status === 'succeeded') {
            // Submit membership application
            const membershipResponse = await fetch('/api/members', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...membershipForm,
                    membershipTier: tier.name,
                    paymentIntentId: result.paymentIntent.id
                }),
            });

            if (membershipResponse.ok) {
                showNotification('Membership purchased successfully!', 'success');
                onPaymentSuccess();
            } else {
                showNotification('Membership application failed', 'error');
            }
            }
            setIsProcessing(false);
      }
    } catch (error) {
      console.error('Payment error:', error);
      showNotification('Payment processing failed', 'error');
      setIsProcessing(false);
    }
  };

  // For free membership, don't render Stripe Elements
  if (tier.price === 'Free' || parseFloat(tier.price.replace('£', '')) === 0) {
    return (
      <form onSubmit={handlePaymentSubmission}>
        <button 
          type="submit" 
          style={{
            ...primaryButtonStyles,
            width: '100%',
          }}
        >
          Register for Free Membership
        </button>
      </form>
    );
  }

  // Existing Stripe payment form for paid memberships
  return (
    <form onSubmit={handlePaymentSubmission}>
                            <label style={{ 
                                    display: 'block', 
                                    marginBottom: '0.5rem', 
                                    fontWeight: '600' }}>
                                Card Details
                            </label> 
      <div style={{
            padding: '1rem',
            border: '2px solid #e1e1e1',
            borderRadius: '10px',
            marginBottom: '1rem'
        }}>                        
        <PaymentElement />
      </div>
      <button 
        type="submit" 
        disabled={isProcessing || !stripe}
        style={{
          ...primaryButtonStyles,
          opacity: isProcessing ? 0.5 : 1,
        }}
      >
        {isProcessing ? 'Processing...' : `Pay ${tier.price}`}
      </button>
    </form>
  );
};

const MembershipPage = ({showNotification}) => {
  const [selectedTier, setSelectedTier] = useState({
      name: "Network Access",
      price: "Free",
      pricerRaw: 0,
      duration: "",
      features: [
        "Access to quarterly networking events with 500+ Saudi-UK professionals",
        "Digital networking directory with verified Saudi business contacts",
        "Exclusive online community with active deal discussions",
        "Saudi business culture and etiquette masterclass library"
      ]
    });
    const [membershipForm, setMembershipForm] = useState({
        first_name: '',
        last_name: '',
        email: '',
        company: '',
        industry: '',
        interests: '',
        phone: ''
    });
    const [visible, setVisible] = useState(false);
    const [clientSecret, setClientSecret] = useState(null);
    

    const handleMembershipSubmit = async (e) => {
        e.preventDefault();
        setVisible(true);
    };

    const membershipTiers = [
    {
      name: "Network Access",
      price: "Free",
      pricerRaw: 0,
      duration: "",
      features: [
        "Access to quarterly networking events with 500+ Saudi-UK professionals",
        "Digital networking directory with verified Saudi business contacts",
        "Exclusive online community with active deal discussions",
        "Saudi business culture and etiquette masterclass library"
      ]
    },
    {
      name: "Professional",
      price: "£499",
      pricerRaw: 499,
      duration: "per year",
      features: [
        "Everything in Network Access PLUS:",
        "Quarterly market intelligence reports",
        "Saudi partner introduction service (up to 3 qualified introductions)",
        "Government regulatory update alerts",
        "Investment opportunity newsletter"
      ],
      popular: true
    },
    {
      name: "Corporate",
      price: "£999",
      pricerRaw: 999,
      duration: "per year",
      features: [
        "Everything in Professional PLUS:",
        "Custom market research report tailored to your sector (1 per year)",
        "Government stakeholder meeting facilitation",
        "Business visa facilitation and travel coordination support",
      ]
    }
  ];

    const industryOptions = [
      'Technology', 'Finance & Banking', 'Energy & Oil', 'Healthcare',
      'Construction & Real Estate', 'Education', 'Tourism & Hospitality',
      'Manufacturing', 'Retail & E-commerce', 'Consulting',
      'Government & Public Sector', 'Other'
    ];

  const handleTierSelection = async (tier) => {
    setSelectedTier(tier);

    const isFree = tier.price === "Free";
    if (isFree) {
        return;
    }
    try {
        const response = await fetch(`/api/create-payment-intent`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                    amount: parseFloat(tier.price.replace('£', '')) * 100, // Convert to cents
                    membershipTier: tier.name,
                    memberDetails: membershipForm
                }),
        });
        const data = await response.json();
        setClientSecret(data.clientSecret);
    } catch (err) {
        console.error('Error creating payment intent:', err);
        showNotification('Failed to initialize payment.', 'error');
    }
  };

  const handlePaymentSuccess = () => {
    // Reset form or navigate away
    setMembershipForm({
      first_name: '',
      last_name: '',
      email: '',
      company: '',
      industry: '',
      interests: '',
      phone: ''
    });
    setVisible(false);
    setClientSecret(null);
    // setSelectedTier(null);
  };

  return (
    <div>
    <section style={pageHeaderStyles}>
          <div style={containerStyles}>
            <h1 style={pageHeaderTitleStyles}>Join Our Network</h1>
            <p style={pageHeaderSubStyles}>
              Become part of the premier community connecting Saudi Arabia and the United Kingdom
            </p>
          </div>
        </section>

      <section style={{...sectionStyles, backgroundColor: '#f8f9fa'}}>
        <div style={containerStyles}>
          <h2 style={sectionTitleStyles}>Membership Options</h2>
          <p style={centerDescStyles}>
            Choose the membership tier that best fits your business needs and growth objectives.
          </p>
          <div style={membershipGridStyles}>
            {membershipTiers.map((tier, index) => (
              <div key={index} style={{
                ...membershipCardStyles,
                ...(tier.name === selectedTier.name ? popularCardStyles : {})
              }}>
                {tier.name === selectedTier.name && <div style={popularBadgeStyles}></div>}
                <div style={membershipHeaderStyles}>
                  <h3 style={membershipNameStyles}>{tier.name}</h3>
                  <div style={membershipPriceStyles}>
                    <span style={priceNumberStyles}>{tier.price}</span>
                    {tier.duration && <span style={priceDurationStyles}>{tier.duration}</span>}
                  </div>
                </div>
                <ul style={membershipFeaturesStyles}>
                  {tier.features.map((feature, idx) => (
                    <li key={idx} style={membershipFeatureStyles}>{feature}</li>
                  ))}
                </ul>
                <button 
                onClick={() => handleTierSelection(tier)}
                style={{
                  ...primaryButtonStyles,
                  ...(tier.name === selectedTier.name ? secondaryButtonStyles : {}),
                  width: '100%',
                  marginTop: '2rem'
                }}>
                  {tier.name === 'Network Access' ? 'Get Started' : 'Choose Plan'}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={sectionStyles}>
          <div style={containerStyles}>
            {/* Enhanced Membership Application Form */}
            <div style={membershipFormSectionStyles}>
              <h2 style={sectionTitleStyles}>Apply for {selectedTier.name} Membership</h2>
              <form onSubmit={handleMembershipSubmit} style={membershipFormStyles}>
                <div style={formRowStyles}>
                  <div style={formGroupStyles}>
                    <label style={labelStyles}>First Name *</label>
                    <input 
                      type="text" 
                      style={inputStyles} 
                      value={membershipForm.first_name}
                      onChange={(e) => setMembershipForm({...membershipForm, first_name: e.target.value})}
                      required 
                    />
                  </div>
                  <div style={formGroupStyles}>
                    <label style={labelStyles}>Last Name *</label>
                    <input 
                      type="text" 
                      style={inputStyles} 
                      value={membershipForm.last_name}
                      onChange={(e) => setMembershipForm({...membershipForm, last_name: e.target.value})}
                      required 
                    />
                  </div>
                </div>
                
                <div style={formGroupStyles}>
                  <label style={labelStyles}>Email Address *</label>
                  <input 
                    type="email" 
                    style={inputStyles} 
                    value={membershipForm.email}
                    onChange={(e) => setMembershipForm({...membershipForm, email: e.target.value})}
                    required 
                  />
                </div>
                
                <div style={formRowStyles}>
                  <div style={formGroupStyles}>
                    <label style={labelStyles}>Company/Organization</label>
                    <input 
                      type="text" 
                      style={inputStyles} 
                      value={membershipForm.company}
                      onChange={(e) => setMembershipForm({...membershipForm, company: e.target.value})}
                    />
                  </div>
                  <div style={formGroupStyles}>
                    <label style={labelStyles}>Phone Number</label>
                    <input 
                      type="tel" 
                      style={inputStyles} 
                      value={membershipForm.phone}
                      onChange={(e) => setMembershipForm({...membershipForm, phone: e.target.value})}
                    />
                  </div>
                </div>
                
                <div style={formGroupStyles}>
                  {/* <div style={formGroupStyles}>
                    <label style={labelStyles}>Membership Tier *</label>
                    <select 
                      style={inputStyles} 
                      value={membershipForm.membership_type}
                      onChange={(e) => setMembershipForm({...membershipForm, membership_type: e.target.value})}
                      required
                    >
                      <option value="">Select membership tier</option>
                      <option value="individual">Individual Professional - £150/year</option>
                      <option value="corporate">Corporate Partnership - £500/year</option>
                      <option value="student">Student & Entrepreneur - £50/year</option>
                    </select>
                  </div> */}
                  <div style={formGroupStyles}>
                    <label style={labelStyles}>Industry</label>
                    <select 
                      style={inputStyles} 
                      value={membershipForm.industry}
                      onChange={(e) => setMembershipForm({...membershipForm, industry: e.target.value})}
                    >
                      <option value="">Select your industry</option>
                      {industryOptions.map(industry => (
                        <option key={industry} value={industry}>{industry}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div style={formGroupStyles}>
                  <label style={labelStyles}>Areas of Interest</label>
                  <textarea 
                    style={textareaStyles} 
                    rows="3" 
                    placeholder="e.g., Technology transfer, Investment opportunities, Cultural exchange, Export/Import..."
                    value={membershipForm.interests}
                    onChange={(e) => setMembershipForm({...membershipForm, interests: e.target.value})}
                  />
                </div>
                
                <button type="submit" style={primaryButtonStyles}>Submit Application</button>
                <p style={formDisclaimerStyles}>
                  * We will review your application within 2 business days and send you payment instructions upon approval.
                </p>
              </form>
            </div>
          </div>
        </section>


      {/* Stripe Payment Modal */}
      {visible && (
        <div style={membershipModal}>
          <div style={membershipContainer}>
            <h2>Complete Payment for {selectedTier.name} Membership</h2>

            { selectedTier.price === "Free" ? 
                <Elements stripe={stripePromise}>
                    <MembershipPaymentForm 
                        tier={selectedTier}
                        membershipForm={membershipForm}
                        showNotification={showNotification}
                        onPaymentSuccess={handlePaymentSuccess}
                    />
                </Elements> :

                <Elements stripe={stripePromise} options={{ clientSecret }}>
                    <MembershipPaymentForm 
                        tier={selectedTier}
                        membershipForm={membershipForm}
                        showNotification={showNotification}
                        onPaymentSuccess={handlePaymentSuccess}
                    />
                </Elements>
            }

            <button 
              onClick={() => setVisible(false)}
              style={{
                ...secondaryButtonStyles,
                ...membershipButton
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MembershipPage;